import { RmToleranceService } from './rm-tolerance.service';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { ApiTags } from '@nestjs/swagger';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { RmToleranceDTO } from './dto/rm-tolerance.dto';
import {RmToleranceRequest} from './dto/rm-tolerance.request';
import { AllRmToleranceResponse, RmToleranceResponse } from '@gtpl/shared-models/raw-material-procurement';
import { UserRequestDto } from '@gtpl/shared-models/common-models';
@Controller('rm-tolerance')
export class RmToleranceController {
    constructor(
        private rmToleranceService: RmToleranceService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
      ) {}
 /**
     * creates  a Rm Tolerance
     * @param RmToleranceDto RmTolerance DTO
     * @returns  rmToleranceResponse
     */
  @Post('/createRmTolerance')
  async createRmTolerance(@Body() rmToleranceDTO:RmToleranceDTO, @Req() request:Request): Promise<RmToleranceResponse> {
      try {
       return await this.rmToleranceService.createRmTolerance(rmToleranceDTO,false,request);
     } catch (error) {
          return this.applicationExceptionHandler.returnException(RmToleranceResponse, error);
     }
   }

    /**
     * gets all the Value rm Tolerance
     * @returns AllRmToleranceResponse which returns all the Value rm-Tolerance  along with status (true/false), errortype, errorCode, internal message which provides message to the calling function.
     */

     @Post('/getAllRmTolerance')
    async getAllRmTolerance(@Body() req?:UserRequestDto): Promise<AllRmToleranceResponse> {
        try {
            return await this.rmToleranceService.getAllRmTolerance(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllRmToleranceResponse, error);
        }
    }

      /**
     * Activate Or De-Activate Value rmTolerance
     * @param getSingleRmTolerance rmTolerance
     * @returns Value RmTolerance
     */
       @Post('/activateOrDeactivateRmTolerance')
       async activateOrDeactivateRmTolerance(@Body() rmToleranceReq: RmToleranceRequest): Promise<RmToleranceResponse> {
           try {
               return await this.rmToleranceService.activateOrDeactivateRmTolerance(rmToleranceReq);
           } catch (err) {
               return this.applicationExceptionHandler.returnException(RmToleranceResponse, err);
           }
       }
       /**
     *  updates a  value rm Tolerance
     * @param RmToleranceDto Rm Tolerance DTO
     * @returns RmToleranceResponse
     */
    @Post('/updateRmTolerance')
    async updateRmTolerance(@Body() rmToleranceDTO:RmToleranceDTO, @Req() request:Request): Promise<RmToleranceResponse> {
        try {
         return await this.rmToleranceService.createRmTolerance(rmToleranceDTO,true,request);
       } catch (error) {
            return this.applicationExceptionHandler.returnException(RmToleranceResponse, error);
       }
     }
}
